import { render, staticRenderFns } from "./sf_task_require.vue?vue&type=template&id=5c4d7ce5&scoped=true&"
import script from "./sf_task_require.vue?vue&type=script&lang=js&"
export * from "./sf_task_require.vue?vue&type=script&lang=js&"
import style0 from "./sf_task_require.vue?vue&type=style&index=0&id=5c4d7ce5&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d7ce5",
  null
  
)

export default component.exports